import React, { useEffect, useState } from "react";
import Image from "../../common/image/Image";
import Layout from "../../layout/base/Layout";
import MarketLogo from "../../../assets/images/Onetransfer-logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
	Drawer,
	Badge,
	Col,
	Tooltip,
	Progress,
	Modal,
	Button,
	Form,
	Input,
	Space,
	message,
} from "antd";
import { RiBookletFill, RiDashboardLine } from "react-icons/ri";
import { AiFillAlert, AiOutlineLineChart } from "react-icons/ai";
import { FiUsers } from "react-icons/fi";
import { ImInsertTemplate } from "react-icons/im";
import { BiLogOut } from "react-icons/bi";
import {
	MdOutlineBusiness,
	MdOutlineComputer,
	MdOutlinePlace,
} from "react-icons/md";
import { RiUserSettingsLine, RiTvLine } from "react-icons/ri";
import { useAuth } from "../../../contexts/authContext";
import Aside from "../../common/aside/Aside";
import SearchProducts from "../../common/search-products/SearchProducts";
import { useCart } from "../../../contexts/cartContext";
import CartIcon from "../../../assets/images/cart-shopping-solid.svg";
import MenuIcon from "../../../assets/images/bars-solid.svg";
import UserIcon from "../../../assets/images/user-solid.svg";
import {
	AuditOutlined,
	DownloadOutlined,
	FormOutlined,
	PhoneOutlined,
	QuestionCircleOutlined,
	RiseOutlined,
	SettingOutlined,
	SnippetsOutlined,
} from "@ant-design/icons";
import MarketLogoIcon from "../../../assets/images/Onetransfer-logo-box.png";
import FooterContainer from "../../containers/layout/FooterContainer";
import { COLORS, SIZES, Typo } from "../../layout/theme";
import { get_client_by_id } from "../../../api/endpoints/clients";
import { useScrollDirection } from "../../../hooks/useScrollDirection";
import { get_total_campaigns_by_region } from "../../../api/endpoints/campaigns";
import { checkOneMarketMenu } from "./components/AsideBarAdminOneMarketData";
import AsideBarSubMenuAdminOneMarket from "./components/AsideBarSubMenuAdminOneMarket";
import PermissionCheckVisibility from "../../common/permission-check-visibility/PermissionCheckVisibility";
import { useBook } from "../../../contexts/bookContext";
import HotSaleIcon from "../../../assets/images/fire-solid.svg";
import moment from "moment";
import { WhatsAppButton } from "../../layout/base/styles";
import { BsWhatsapp } from "react-icons/bs";
import {
	DropdownLink,
	IconContainer,
	LaboratorySidebarLink,
	MenuAlertContainer,
	SidebarLabel,
} from "./components/styles";
import { checkBuyerProgressPercentage } from "../../../utils/checkBuyerProgressPercentage";
import { checkSellerProgressPercentage } from "../../../utils/checkSellerProgressPercentage";
import { checkRolPermission } from "../../../utils/checkRolPermission";
import { useFilter } from "../../../contexts/filterContext";
import MarketHeader from "./components/market-header/MarketHeader";
import PharmacyHeader from "./components/pharmacy-header/PharmacyHeader";
import LaboratoryHeader from "./components/laboratory-header/LaboratoryHeader";
import PhoneInput from "../../common/phone-input/PhoneInput";
import { update_user_whatsapp } from "../../../api/endpoints/users";
import { CONSTANTS } from "../../../utils/constants";

export default function LayoutContainer({ children, clientUser }) {
	const {
		user,
		userdata,
		ready,
		logout,
		requestsQty,
		mobileRequestsQty,
		ordersQty,
		toValidateQty,
		changePhoto,
		setPhotoKey,
		browserInfo,
		bannerRequestQty,
	} = useAuth();
	const { setUserRol } = useFilter();
	const { qty, templateProducts } = useCart();
	const { bookQty } = useBook();
	const [showDrawer, setShowDrawer] = useState(false);
	const [photo, setPhoto] = useState(false);
	const [pharmaName, setPharmaName] = useState(null);
	const [clientSlug, setClientSlug] = useState(null);
	const [clientPhotoUrl, setClientPhotoUrl] = useState(null);
	const [campaignRegion, setCampaignRegion] = useState(null);
	const [percent, setPercent] = useState(0);
	const scrollDirection = useScrollDirection();
	const location = useLocation();
	const navigate = useNavigate();
	const [reportSubNav, setReportSubnav] = useState(false);
	const [mobileSubNav, setMobileSubnav] = useState(false);
	const [mobileActive, setMobileActive] = useState(false);
	const [eventSubNav, setEventSubnav] = useState(false);
	const [laboratoryAccountSubNav, setLaboratoryAccountSubnav] = useState(false);
	const [expoActive, setExpoActive] = useState(false);
	const [discountForUserActive, setDiscountForUserActive] = useState(false);
	const [contractZoneType, setContractZoneType] = useState(null);
	const [webActive, setWebActive] = useState(false);
	const [webSellerSubNav, setWebSellerSubnav] = useState(false);
	const [webSellerActive, setWebSellerActive] = useState(false);
	const [couponSubNav, setCouponSubnav] = useState(false);
	const [couponActive, setCouponActive] = useState(false);
	const [showWhatsappModal, setShowWhatsappModal] = useState(false);
	const [savingWhatsapp, setSavingWhatsapp] = useState(false);
	const [formWhatsapp] = Form.useForm();
	const [localWhatsappUserId, setLocalWhatsappUserId] = useState(null);
	const [whatsappModalEvaluated, setWhatsappModalEvaluated] = useState(false);

	useEffect(() => {
		setLocalWhatsappUserId(clientUser?.whatsappUserId ?? null);
	}, [clientUser?.whatsappUserId]);

	const hasWhatsapp = !!localWhatsappUserId;

	const isHome = location?.pathname === "/";

	useEffect(() => {
		if (whatsappModalEvaluated) return;

		const canEvaluate = !!clientUser?.id && !!userdata;

		if (
			canEvaluate &&
			isHome &&
			!hasWhatsapp &&
			!userdata.isOneMarket &&
			!userdata.isSeller
		) {
			setShowWhatsappModal(true);
			formWhatsapp.setFieldsValue({ whatsappUserId: "" });
			setWhatsappModalEvaluated(true);
		}
	}, [
		whatsappModalEvaluated,
		isHome,
		hasWhatsapp,
		clientUser?.id,
		userdata,
		formWhatsapp,
	]);

	useEffect(() => {
		if (showWhatsappModal && hasWhatsapp) {
			setShowWhatsappModal(false);
		}
	}, [showWhatsappModal, hasWhatsapp]);

	async function signOut() {
		await logout();
		setShowDrawer(false);
		navigate("/");
		window.location.reload();
	}

	useEffect(() => {
		if (userdata?.isSeller) {
			setPercent(() => checkSellerProgressPercentage(userdata));
		} else {
			setPercent(() => checkBuyerProgressPercentage(userdata));
		}
	}, [userdata]);

	const fetch_data = async (id) => {
		const res = await get_client_by_id(id);

		const now = moment().milliseconds();

		setPhoto({
			url: res?.userPhoto + `?k=${now}`,
			key: now,
		});
		setPhotoKey(now);
		setPharmaName(res.client.businessName);
		setClientSlug(res.client?.slug);
		setClientPhotoUrl(res.client?.photoUrl);
		setMobileActive(res.client?.contract?.activeMobileApp);
		setExpoActive(res.client?.contract?.activeExpoSection);
		setWebSellerActive(res.client?.contract?.activeWebSeller);
		setCouponActive(res.client?.contract?.activeCouponSection);
		setWebActive(res.client?.contract?.activeClientWeb);
		setDiscountForUserActive(res.client?.contract?.activeDiscountsForUsers);
		setContractZoneType(res.client?.contract?.mobileUsersZoneType);
		setUserRol(
			checkRolPermission(userdata, {
				...res.client,
				isOneMarket: userdata.isOneMarket,
			}),
		);
	};

	useEffect(() => {
		fetch_data(userdata.clientId);
	}, [changePhoto]);

	useEffect(() => {
		const fetch_campaign_region = async () => {
			const res = await get_total_campaigns_by_region();
			setCampaignRegion(res);
		};

		fetch_campaign_region();
	}, []);

	const showReportSubnav = () => setReportSubnav((prev) => !prev);
	const showMobileSubnav = () => setMobileSubnav((prev) => !prev);
	const showEventSubnav = () => setEventSubnav((prev) => !prev);
	const showWebSellerSubnav = () => setWebSellerSubnav((prev) => !prev);
	const showLaboratoryAccountSubnav = () =>
		setLaboratoryAccountSubnav((prev) => !prev);
	const showCouponSubnav = () => setCouponSubnav((prev) => !prev);

	const handleWhatsappIconClick = (e) => {
		if (hasWhatsapp) return;

		e.preventDefault();
		setShowWhatsappModal(true);
	};

	const handleSaveWhatsapp = async () => {
		try {
			const userId = clientUser?.id;
			if (!userId) {
				message.error("No se pudo identificar el usuario actual.");
				return;
			}

			const values = await formWhatsapp.validateFields();

			setSavingWhatsapp(true);

			const payload = {
				id: userId,
				whatsappUserId:
					"549" + values.whatsappUserId?.replace(/\D/g, "").slice(-10),
				phone:
					values.phoneAreaCode && values.phone
						? `${values.phoneAreaCode}${values.phone}`
						: null,
				optedOutWhatsApp: false,
				clientId: clientUser?.client?.id ?? CONSTANTS.ONE_TRANSFER_CLIENT_ID,
			};

			await update_user_whatsapp(payload);

			setLocalWhatsappUserId(payload.whatsappUserId);
			message.success("WhatsApp actualizado.");
			setShowWhatsappModal(false);
		} catch (e) {
			console.error(e);
			message.error("No se pudo actualizar el WhatsApp.");
		} finally {
			setSavingWhatsapp(false);
		}
	};

	return (
		<Layout>
			{!ready ? (
				"Loading..."
			) : userdata.isOneMarket ? (
				<MarketHeader
					scrollDirection={scrollDirection}
					userdata={userdata}
					location={location}
					templateProducts={templateProducts}
					bookQty={bookQty}
					qty={qty}
					setShowDrawer={setShowDrawer}
					showDrawer={showDrawer}
					browserInfo={browserInfo}
				/>
			) : userdata.isSeller ? (
				<LaboratoryHeader
					scrollDirection={scrollDirection}
					userdata={userdata}
					campaignRegion={campaignRegion}
					templateProducts={templateProducts}
					location={location}
					bookQty={bookQty}
					qty={qty}
					setShowDrawer={setShowDrawer}
					showDrawer={showDrawer}
					browserInfo={browserInfo}
					clientPhotoUrl={clientPhotoUrl}
					clientSlug={clientSlug}
				/>
			) : (
				<PharmacyHeader
					scrollDirection={scrollDirection}
					userdata={userdata}
					campaignRegion={campaignRegion}
					location={location}
					clientSlug={clientSlug}
					pharmaName={pharmaName}
					templateProducts={templateProducts}
					bookQty={bookQty}
					qty={qty}
					setShowDrawer={setShowDrawer}
					showDrawer={showDrawer}
					browserInfo={browserInfo}
					userId={user.uid}
				/>
			)}
			<Layout.Main>{children}</Layout.Main>
			<Drawer
				title=""
				headerStyle={{ display: "none" }}
				placement="right"
				onClose={() => setShowDrawer(false)}
				visible={showDrawer}
				zIndex={998}
			>
				<Aside>
					{!ready ? (
						"Loading..."
					) : userdata.isOneMarket ? (
						<Aside.Actions>
							<Aside.Separator>
								<Link to="/profile" onClick={() => setShowDrawer(false)}>
									<Layout.HeaderAction
										style={{
											width: "150px",
											wordBreak: "break-word",
											left: "-12px",
										}}
									>
										<Layout.HeaderUserIconContainer>
											<Layout.HeaderUserIcon>
												<Image
													src={photo.url ? photo.url : UserIcon}
													alt="User"
													style={{
														width: "36px",
														height: "36px",
														borderRadius: "50%",
													}}
													key={photo.key}
												/>
											</Layout.HeaderUserIcon>
											<Layout.HeaderUserParagraph>
												<Layout.HeaderSpan>
													{userdata?.firstName}
												</Layout.HeaderSpan>
												<Layout.HeaderSpan>
													<Typo type="primary" level={7} lineHeight={0}>
														OneMarket
													</Typo>
												</Layout.HeaderSpan>
											</Layout.HeaderUserParagraph>
										</Layout.HeaderUserIconContainer>
									</Layout.HeaderAction>
								</Link>
								<Aside.Action> </Aside.Action>
								<Aside.Action> </Aside.Action>
								{checkOneMarketMenu(userdata)?.map((item, index) => {
									return (
										<AsideBarSubMenuAdminOneMarket
											item={item}
											key={index}
											setShowDrawer={setShowDrawer}
											requestsQty={requestsQty}
											mobileRequestsQty={mobileRequestsQty}
											ordersQty={ordersQty}
											toValidateQty={toValidateQty}
											bannerRequestQty={bannerRequestQty}
										/>
									);
								})}
								<Aside.Action> </Aside.Action>
								<Aside.Action> </Aside.Action>
								<Link to="/">
									<Aside.Action onClick={() => signOut()}>
										<BiLogOut color={COLORS.Primary} />
										Cerrar Sesión
									</Aside.Action>
								</Link>
							</Aside.Separator>
						</Aside.Actions>
					) : !ready ? (
						"Loading..."
					) : userdata.isSeller ? (
						<Aside.Actions>
							<Aside.Separator>
								<Link to="/profile" onClick={() => setShowDrawer(false)}>
									<Layout.HeaderAction
										style={{
											width: "150px",
											wordBreak: "break-word",
											left: "-12px",
										}}
									>
										<Layout.HeaderUserIconContainer>
											<Layout.HeaderUserIcon>
												<Image
													src={photo ? photo : UserIcon}
													alt="User"
													style={{
														width: "36px",
														height: "36px",
														borderRadius: "50%",
													}}
												/>
											</Layout.HeaderUserIcon>
											<Layout.HeaderUserParagraph>
												<Layout.HeaderSpan>
													{userdata?.firstName}
												</Layout.HeaderSpan>
												<Layout.HeaderSpan>
													<Typo type="primary" level={7} lineHeight={0}>
														{pharmaName}
													</Typo>
												</Layout.HeaderSpan>
											</Layout.HeaderUserParagraph>
										</Layout.HeaderUserIconContainer>
									</Layout.HeaderAction>
								</Link>
								<Aside.Action> </Aside.Action>
								<Aside.Action> </Aside.Action>
								<PermissionCheckVisibility
									permission={userdata.isSeller && userdata.p_client}
								>
									<Link to="/generalConfig">
										<Aside.Action onClick={() => setShowDrawer(false)}>
											<SettingOutlined style={{ color: COLORS.Primary }} />
											Configuración General
										</Aside.Action>
									</Link>
								</PermissionCheckVisibility>
								<PermissionCheckVisibility
									permission={
										userdata.isSeller &&
										userdata.p_dashboard &&
										userdata.p_sales
									}
								>
									<Link to="/homeMarketplace">
										<Aside.Action onClick={() => setShowDrawer(false)}>
											<MdOutlineComputer style={{ color: COLORS.Primary }} />
											Marketplace
										</Aside.Action>
									</Link>
								</PermissionCheckVisibility>
								<PermissionCheckVisibility
									permission={
										userdata.isSeller &&
										userdata.p_dashboard &&
										userdata.p_sales
									}
								>
									<LaboratorySidebarLink to="#" onClick={showReportSubnav}>
										<div>
											<RiDashboardLine color={COLORS.Primary} />{" "}
											<SidebarLabel>Reportes</SidebarLabel>
										</div>
									</LaboratorySidebarLink>
								</PermissionCheckVisibility>
								{reportSubNav && (
									<div style={{ display: "flex", flexDirection: "column" }}>
										<DropdownLink to="/admin/dashboard">
											<div onClick={() => setShowDrawer(false)}>
												<RiDashboardLine color={COLORS.Primary} />
												<SidebarLabel>Dashboard</SidebarLabel>
											</div>
										</DropdownLink>
										<DropdownLink to="/admin/interactionReport">
											<div onClick={() => setShowDrawer(false)}>
												<RiseOutlined style={{ color: COLORS.Primary }} />
												<SidebarLabel>Productos</SidebarLabel>
											</div>
										</DropdownLink>
										{/* <DropdownLink to="/admin/laboratoryAuditory">
											<div onClick={() => setShowDrawer(false)}>
												<DownloadOutlined style={{ color: COLORS.Primary }} />
												<SidebarLabel>Auditoria</SidebarLabel>
											</div>
										</DropdownLink>
										<DropdownLink to="/admin/laboratoryDistributorResponse">
											<div onClick={() => setShowDrawer(false)}>
												<SnippetsOutlined style={{ color: COLORS.Primary }} />
												<SidebarLabel>Estado ordenes</SidebarLabel>
											</div>
										</DropdownLink> */}
									</div>
								)}
								<PermissionCheckVisibility
									permission={
										(userdata.isSeller &&
											!userdata.p_dashboard &&
											userdata.p_sales &&
											userdata.p_shop) ||
										(userdata.isSeller &&
											userdata.p_dashboard &&
											userdata.p_client) ||
										(userdata.isSeller &&
											!userdata.p_client &&
											!userdata.p_users &&
											!userdata.p_products &&
											!userdata.p_dashboard &&
											userdata.p_sales &&
											!userdata.p_shop &&
											userdata.p_mobile)
									}
								>
									<Link to="/admin/ventas">
										<Aside.Action onClick={() => setShowDrawer(false)}>
											<AiOutlineLineChart color={COLORS.Primary} />
											Ventas
										</Aside.Action>
									</Link>
								</PermissionCheckVisibility>
								<Aside.Action> </Aside.Action>
								<Aside.Action> </Aside.Action>
								<Link to="#">
									<Aside.Action onClick={() => signOut()}>
										<BiLogOut color={COLORS.Primary} />
										Cerrar Sesión
									</Aside.Action>
								</Link>
							</Aside.Separator>
							<Aside.Action> </Aside.Action>
							{/* <PermissionCheckVisibility permission={userdata.p_client}>
								<Link to="/startGuide">
									<Aside.Action onClick={() => setShowDrawer(false)}>
										<QuestionCircleOutlined style={{ color: COLORS.Primary }} />
										Guía de Inicio
										{!userdata?.isOneMarket && (
											<MenuAlertContainer>
												{userdata?.guideProgress === 0 ? (
													<AiFillAlert
														color={COLORS.Danger}
														style={{ width: 15 }}
													/>
												) : (
													<Progress
														type="circle"
														percent={percent}
														width={30}
													/>
												)}
											</MenuAlertContainer>
										)}
									</Aside.Action>
								</Link>
							</PermissionCheckVisibility> */}
						</Aside.Actions>
					) : (
						<Aside.Actions>
							<Aside.Separator>
								<Link to="/profile" onClick={() => setShowDrawer(false)}>
									<Layout.HeaderAction
										style={{
											width: "150px",
											wordBreak: "break-word",
											position: "relative",
											left: "-12px",
										}}
									>
										<Layout.HeaderUserIconContainer>
											<Layout.HeaderUserIcon>
												<Image
													src={photo ? photo : UserIcon}
													alt="User"
													style={{
														width: "36px",
														height: "36px",
														borderRadius: "50%",
													}}
												/>
											</Layout.HeaderUserIcon>
											<Layout.HeaderUserParagraph>
												<Layout.HeaderSpan>
													{userdata?.firstName}
												</Layout.HeaderSpan>
												<Layout.HeaderSpan>
													<Typo type="primary" level={7} lineHeight={0}>
														{pharmaName}
													</Typo>
												</Layout.HeaderSpan>
											</Layout.HeaderUserParagraph>
										</Layout.HeaderUserIconContainer>
									</Layout.HeaderAction>
								</Link>
								<Aside.Action> </Aside.Action>
								<Aside.Action> </Aside.Action>
								<PermissionCheckVisibility permission={userdata.p_dashboard}>
									<Link to="/admin/dashboard">
										<Aside.Action onClick={() => setShowDrawer(false)}>
											<RiDashboardLine color={COLORS.Primary} />
											Dashboard
										</Aside.Action>
									</Link>
								</PermissionCheckVisibility>
								<Link to="/admin/compras">
									<Aside.Action onClick={() => setShowDrawer(false)}>
										<AiOutlineLineChart color={COLORS.Primary} />
										Mis Compras
									</Aside.Action>
								</Link>
								<PermissionCheckVisibility permission={userdata.p_shop}>
									<Link to="/admin/templates">
										<Aside.Action onClick={() => setShowDrawer(false)}>
											<ImInsertTemplate color={COLORS.Primary} />
											Plantillas
										</Aside.Action>
									</Link>
								</PermissionCheckVisibility>
								{/* <PermissionCheckVisibility permission={userdata.p_shop}>
									<Link to="/admin/marketing">
										<Aside.Action onClick={() => setShowDrawer(false)}>
											<RiTvLine color={COLORS.Primary} />
											Campañas Publicitarias
										</Aside.Action>
									</Link>
								</PermissionCheckVisibility> */}
								<Aside.Action> </Aside.Action>
								<Aside.Action> </Aside.Action>
								<PermissionCheckVisibility permission={userdata.p_client}>
									<Link to="/admin/pointsofsale">
										<Aside.Action onClick={() => setShowDrawer(false)}>
											<MdOutlinePlace color={COLORS.Primary} />
											Puntos de venta
										</Aside.Action>
									</Link>
								</PermissionCheckVisibility>
								<PermissionCheckVisibility permission={userdata.p_users}>
									<Link to="/admin/users">
										<Aside.Action onClick={() => setShowDrawer(false)}>
											<FiUsers color={COLORS.Primary} />
											Usuarios y Permisos
										</Aside.Action>
									</Link>
								</PermissionCheckVisibility>
								<PermissionCheckVisibility permission={userdata.p_client}>
									<Link to="/admin/account">
										<Aside.Action onClick={() => setShowDrawer(false)}>
											<RiUserSettingsLine color={COLORS.Primary} />
											Datos de la cuenta
										</Aside.Action>
									</Link>
								</PermissionCheckVisibility>
								<Aside.Action> </Aside.Action>
								<Aside.Action> </Aside.Action>
								<Link to="#">
									<Aside.Action onClick={() => signOut()}>
										<BiLogOut color={COLORS.Primary} />
										Cerrar Sesión
									</Aside.Action>
								</Link>
							</Aside.Separator>
							<Aside.Action> </Aside.Action>
							<PermissionCheckVisibility permission={userdata.p_client}>
								<Link to="/startGuide">
									<Aside.Action onClick={() => setShowDrawer(false)}>
										<QuestionCircleOutlined style={{ color: COLORS.Primary }} />
										Guía de Inicio
										{!userdata?.isOneMarket && (
											<MenuAlertContainer>
												{userdata?.guideProgress === 0 ? (
													<AiFillAlert
														color={COLORS.Danger}
														style={{ width: 15 }}
													/>
												) : (
													<Progress
														type="circle"
														percent={percent}
														width={30}
													/>
												)}
											</MenuAlertContainer>
										)}
									</Aside.Action>
								</Link>
							</PermissionCheckVisibility>
						</Aside.Actions>
					)}
				</Aside>
			</Drawer>
			{!userdata.isOneMarket && !userdata.isSeller && (
				<WhatsAppButton>
					<a
						href={`https://wa.me/5491178540011?text=Hola,%20soy%20${
							userdata.firstName
						}%20de%20${"farmacia"}%20${pharmaName},%20quiero%20hacer%20un%20pedido.`}
						target="blank"
						onClick={handleWhatsappIconClick}
						style={{
							justifyContent: "center",
							alignItems: "center",
							display: "flex",
						}}
					>
						<Typo
							type="white"
							level={1}
							style={{ transform: "translate(1px, 3.5px)" }}
						>
							<BsWhatsapp />
						</Typo>
					</a>
				</WhatsAppButton>
			)}

			<Modal
				open={showWhatsappModal}
				centered
				maskClosable
				onCancel={() => setShowWhatsappModal(false)}
				getContainer={false}
				title="Accede a mejores ofertas por WhatsApp"
				destroyOnClose
				footer={
					<Space>
						<Button onClick={() => setShowWhatsappModal(false)}>
							Más tarde
						</Button>
						<Button
							type="primary"
							loading={savingWhatsapp}
							onClick={handleSaveWhatsapp}
						>
							Guardar
						</Button>
					</Space>
				}
			>
				<Typo level={6} type="primary">
					Dejanos un número de WhatsApp para que nuestro Agente AI pueda
					enviarte ofertas de productos y gestionar tus pedidos de forma simple
					y directa.
				</Typo>

				<ul style={{ marginTop: 12 }}>
					<li>
						<Typo level={6} type="primary">
							Ofertas concretas
						</Typo>
					</li>
					<li>
						<Typo level={6} type="primary">
							Productos sugeridos para tu farmacia
						</Typo>
					</li>
					<li>
						<Typo level={6} type="primary">
							Conversación 1 a 1 con un agente IA
						</Typo>
					</li>
					<li>
						<Typo level={6} type="primary">
							Podés dejar de recibir mensajes cuando quieras
						</Typo>
					</li>
				</ul>

				<Form form={formWhatsapp} layout="vertical">
					{/* <PhoneInput
						form={formWhatsapp}
						size="default"
						label="Teléfono de Contacto (opcional)"
						labelStyle={{
							color: COLORS.Primary,
							fontWeight: "600",
						}}
					/> */}

					<Form.Item
						label={
							<Typo level={6} type="primary">
								WhatsApp
							</Typo>
						}
						name="whatsappUserId"
						rules={[
							{ required: true, message: "Este campo es obligatorio" },
							{
								pattern: new RegExp(/^(?!\s*$)[0-9\s]*$/),
								message: "Solo números (sin caracteres especiales)",
							},
						]}
					>
						<Input
							maxLength={120}
							addonBefore="549"
							placeholder="11 2345 6789"
						/>
					</Form.Item>
					<Typo level={6} type="secondary">
						Usaremos tu WhatsApp únicamente para ofrecerte productos y gestionar
						pedidos dentro de OneTransfer. No enviamos publicidad genérica ni
						compartimos tu número con terceros.
					</Typo>
				</Form>
			</Modal>

			<FooterContainer img={MarketLogoIcon}></FooterContainer>
		</Layout>
	);
}
